var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { msg } from '@lit/localize';
import { html } from 'lit';
import { customElement, property, query, state, } from 'lit/decorators.js';
import { map } from 'lit/directives/map.js';
import { v4 as uuidv4 } from 'uuid';
import { BaseShadowless } from '../indicator/BaseShadowless';
import DragAndDropHelper from './controls/dragAndDrop/drangAndDrop';
/**
 * Represents the layers manager selector
 */
let DinapsisMapLayerManager = class DinapsisMapLayerManager extends BaseShadowless {
    constructor() {
        super();
        /**
         * The current height of map
         */
        this.mapHeight = '100%';
        /**
        * A property that is used to load the base layers of map.
        */
        this.baseLayer = [];
        /**
         * A property tha is user to load the custom layers of map.
         */
        this.overlayLayers = [];
        /**
         * The options of the menu that should be shown for each layer.
         */
        this.layerToolbarConfig = {
            showVisibility: true,
            showOpacity: true,
            showDelete: true,
        };
        /**
         * A property that is used to show or hide layer manager menu.
         */
        this.showLayerManager = false;
        /**
         * A property that is used to store the ids of layer that should show legend opened
         */
        this.layersState = [];
        /**
         * If we want to animate the open of the legend or not.
         * When drag and drop is used its value will be false in order
         * to not animate items that are already open.
         */
        this.animation = true;
        /**
         * A property that is used to generate unique id
         */
        this.componentId = `${uuidv4()}`;
        this.emitchangeLayerOrderEvent = this.emitchangeLayerOrderEvent.bind(this);
    }
    /**
    * A function that emit an event when the button show layers is clicked
    */
    handleBtnClick(e) {
        e.stopPropagation();
        this.showLayerManager = !this.showLayerManager;
    }
    /**
     * A function that change button style when its clicked on button show layers
     * @returns css class for the button
     */
    getButtonStyle() {
        if (this.showLayerManager) {
            return 'dinapsis-map-layer-manager-button-alternative';
        }
        return 'dinapsis-map-layer-manager-button';
    }
    /**
     * A function that emits the base layer event
     * @param e Custom event to emit with base layer info
     */
    changeBaseLayer(e) {
        const { baseLayer } = e.detail;
        this.dispatchEvent(new CustomEvent('changeBaseLayer', { detail: { baseLayer } }));
    }
    /**
     * Launch event to change visibility
     * @param ev Event
     */
    changeVisibility(ev) {
        this.dispatchEvent(new CustomEvent('change-visibility', ev));
    }
    /**
     * Launch event to change visibility layer
     * @param ev Event
     */
    changeVisibilityLayer(ev) {
        this.dispatchEvent(new CustomEvent('change-visibility-layer', ev));
    }
    /**
     * Launch event to change opacity
     * @param ev Event
     */
    changeOpacity(ev) {
        this.dispatchEvent(new CustomEvent('change-opacity', ev));
    }
    /**
     * Launch event when menu option is clicker
     * @param ev Event
     */
    menuOptionClicked(ev) {
        this.dispatchEvent(new CustomEvent('option-clicked', ev));
    }
    /**
     * Manage event of toggle legend and updates inmutable array to launch reactivity
     * @param ev Event
     */
    toggleLegend(ev) {
        const { layerId, open } = ev.detail;
        // Change opened state value
        const ids = this.layersState.map((x) => x.id);
        const index = ids.indexOf(layerId);
        if (index > -1)
            this.layersState[index].opened = open;
        // Force update in order to repaint child components and toggle legend
        this.requestUpdate();
    }
    /**
     * Manage event of toggle opacity and updates inmutable array to launch reactivity
     * @param ev Event
     */
    toggleOpacity(ev) {
        const { layerId, opacityOpened } = ev.detail;
        // Change opened state value
        const ids = this.layersState.map((x) => x.id);
        const index = ids.indexOf(layerId);
        if (index > -1)
            this.layersState[index].opacityOpened = opacityOpened;
        // Force update in order to repaint child components and toggle legend
        this.requestUpdate();
    }
    /**
     * Launch event when overlay layer is deleted.
     * @param ev Event
     */
    deleteOverlayLayer(ev) {
        this.dispatchEvent(new CustomEvent('delete-overlay-layer', ev));
    }
    /**
     * A function that show or hide map base layer if exist more than two options,
     * othewise the component is not visible.
     * @returns Html that represent the map base layer.
     */
    renderMapBaseLayer() {
        if (this.baseLayer.length > 1) {
            return html `<dinapsis-map-base-layer
        .baseLayers="${this.baseLayer}"
        @changeBaseLayer="${this.changeBaseLayer}">
        </dinapsis-map-base-layer>`;
        }
        return html ``;
    }
    emitchangeLayerOrderEvent(layerIdMoved, newIndex) {
        // Avoid open legend animation when drag and drop is used
        this.animation = false;
        this.dispatchEvent(new CustomEvent('change-layer-order', { detail: { layerIdMoved, newIndex } }));
    }
    willUpdate() {
        if (this.dragAndDropHelper) {
            this.dragAndDropHelper.remove();
        }
        this.dragAndDropHelper = null;
    }
    async updated() {
        this.dragAndDropHelper = new DragAndDropHelper(this.componentId, this.emitchangeLayerOrderEvent);
        this.dragAndDropHelper.initializeDragAndDrop(this.overlayLayers);
        this.layersState = this.overlayLayers.map((oL) => {
            const ids = this.layersState.map((x) => x.id);
            const index = ids.indexOf(oL.id);
            if (index === -1)
                return { id: oL.id, opened: false, opacityOpened: false };
            return this.layersState[index];
        });
        await this.updateComplete;
        // Activate animations of legend again
        this.animation = true;
    }
    /**
     * Check draggable click
     * @param e Event
     */
    checkDraggableClick(e) {
        const draggableItems = [...this.dragContainer.querySelectorAll('.draggable-layer-item-container')];
        if (e.target.closest('.range-container')) {
            for (let index = 0; index < draggableItems.length; index += 1) {
                draggableItems[index].draggable = false;
            }
        }
        else {
            for (let index = 0; index < draggableItems.length; index += 1) {
                const isHidden = this.overlayLayers[index].hidden;
                draggableItems[index].draggable = (isHidden === undefined || isHidden === false);
            }
        }
    }
    /**
     * A function that show or hide layer manager container when button is clicked.
     * @returns Html that represent the layer manager.
     */
    renderLayerManagerContainer() {
        if (this.showLayerManager) {
            const title = msg('layers');
            return html `
        <div class="dinapsis-map-layer-manager-container">
          <span class="layer-manager-title" >${title}</span>
          <div class="dinapsis-map-layer-manager-content" style="max-height: ${`calc(${this.mapHeight} - 218px)`};">
            ${this.renderMapBaseLayer()}
            <div class="layer-manager-container">
            ${map(this.overlayLayers, (layer, index) => html `
            ${this.renderElementLayerItem(layer, index)}
            `)}
            </div>
          </div>
      </div>
        `;
        }
        return html ``;
    }
    /**
     * Dispatch center-on event.
     * @param ev Custom event with layer deail.
     */
    centerOn(ev) {
        const { layer } = ev.detail;
        this.dispatchEvent(new CustomEvent('center-on', { detail: { layer } }));
    }
    /**
     * Render a layer item
     * @returns Html that represent the component.
     */
    renderElementLayerItem(layer, index) {
        var _a, _b;
        const isNotHidden = (layer.hidden === undefined || layer.hidden === false);
        let htmLayer = html ``;
        // Be careful. If any class name or attribute of this template is changed,
        // drag and drop could stop working
        htmLayer = html `
        <div class="layer-item-separator" layerIndex="${index}" layerId="${layer.id}" fixedIndex=${isNotHidden ? 'false' : 'true'}></div>
        <div class="draggable-layer-item-container"
          id="${`${this.componentId}_layer_item_${layer.id}`}" 
          layerIndex="${index}" 
          layerId="${layer.id}" 
          style="${isNotHidden ? '' : 'display: none'}"
          fixedIndex=${isNotHidden ? 'false' : 'true'}
          draggable="${isNotHidden ? 'true' : 'false'}" 
          @mousedown=${this.checkDraggableClick}>

          <dinapsis-map-element-layer-item class="element-layer-item"
            .overlayLayer=${layer}
            .zindex=${index}
            .layerToolbarConfig=${this.layerToolbarConfig}
            .opened=${(_a = this.layersState.find((x) => x.id === layer.id)) === null || _a === void 0 ? void 0 : _a.opened}
            .opacityOpened=${(_b = this.layersState.find((y) => y.id === layer.id)) === null || _b === void 0 ? void 0 : _b.opacityOpened}
            .animation="${isNotHidden ? this.animation : false}"
            @change-visibility="${this.changeVisibility}"
            @change-visibility-layer="${this.changeVisibilityLayer}"
            @change-opacity="${this.changeOpacity}"
            @delete-overlay-layer="${this.deleteOverlayLayer}"
            @option-clicked="${this.menuOptionClicked}"
            @toggle-legend="${this.toggleLegend}"
            @toggle-opacity="${this.toggleOpacity}"
            @center-on="${this.centerOn}">
          </dinapsis-map-element-layer-item>
        </div>
        ${this.renderSeparatorLastLayer(index)}`;
        return htmLayer;
    }
    /**
     * Show layer separator if last
     * @param index index by layer.
     * @returns HTML to display.
     */
    renderSeparatorLastLayer(index) {
        if (index === (this.overlayLayers.length - 1)) {
            return html `<div class="layer-item-separator last-separator" id="${`${this.componentId}_last_separator`}" layerIndex="${index}"></div>`;
        }
        return html ``;
    }
    /**
     * The function returns a string of HTML that contains a div that contains the component.
     * @returns The return statement is returning the html template literal
     */
    render() {
        return html `
          <div class="${this.getButtonStyle()}" @click=${this.handleBtnClick}>
            <span class="material-icons-round dinapsis-map-icon">
              layers
            </span>
          </div>
          ${this.renderLayerManagerContainer()}`;
    }
};
__decorate([
    state(),
    property({ type: String })
], DinapsisMapLayerManager.prototype, "mapHeight", void 0);
__decorate([
    state(),
    property({ type: (Array) })
], DinapsisMapLayerManager.prototype, "baseLayer", void 0);
__decorate([
    state(),
    property({ type: (Array) })
], DinapsisMapLayerManager.prototype, "overlayLayers", void 0);
__decorate([
    property({ type: Object })
], DinapsisMapLayerManager.prototype, "layerToolbarConfig", void 0);
__decorate([
    state()
], DinapsisMapLayerManager.prototype, "showLayerManager", void 0);
__decorate([
    query('.layer-manager-container')
], DinapsisMapLayerManager.prototype, "dragContainer", void 0);
DinapsisMapLayerManager = __decorate([
    customElement('dinapsis-map-layer-manager')
], DinapsisMapLayerManager);
export { DinapsisMapLayerManager };
//# sourceMappingURL=dinapsis-map-layer-manager.js.map